import { useEffect } from 'react';

import { usePortletConfig } from 'js/components/system/Portlet';

import { useGamesSelector } from '@interlayer/js/app/components/main/Games/store/context';

export const useSetGapTile = () => {
    const { gameComponentRef } = useGamesSelector();
    const { gamesConfiguration: { gapTile } = {} } = usePortletConfig();

    useEffect(() => {
        if (!gapTile || !gameComponentRef) {
            return;
        }

        gameComponentRef.current.style.setProperty('--global-gap', `${gapTile}px`);
        gameComponentRef.current.style.setProperty('--gap-aspect', gapTile);
    }, [gameComponentRef, gapTile]);
};
